import React from "react";
import "./ScreenHeader.css";

const ScreenHeader = ({
  title,
  elementCount,
  actions,
  secondaryData,
  className = "",
  style = {},
  iconComponent,
}) => {
  return (
    <div className={`screen-header-container ${className}`} style={style}>
      <div style={{ display: "flex", gap: "12px" }}>
        <div style={{ display: "flex", gap: "12px", alignItems: "center" }}>
          <h5
            style={{
              fontSize: "20px",
              marginBottom: "0px",
              display: "flex",
              gap: "6px",
            }}
          >
            <span>{title} </span>

            {elementCount !== undefined &&
              typeof elementCount === "number" &&
              elementCount >= 0 && (
                <div>
                  <span
                    style={{
                      fontSize: "18px",
                      color: "gray",
                      fontWeight: "400",
                    }}
                  >{`(${elementCount})`}</span>
                </div>
              )}
          </h5>
          {iconComponent && (
            <div style={{ display: "flex", alignItems: "center" }}>
              {iconComponent}
            </div>
          )}
        </div>

        {secondaryData && secondaryData}
      </div>

      <div
        className="screen-header-actions-container"
        style={{ display: "flex", gap: "12px" }}
      >
        {actions}
      </div>
    </div>
  );
};

export default ScreenHeader;
